import { FlexContent, TableCell, TableHeadCell, TableRow } from "@rothoblaas/design-system";
import { FC, useRef } from "react";
import { useAuthContext } from "../../context/authContext";
import useListFilters from "../../hooks/useListFilters";
import useI18n from "../../hooks/useTranslations";
import { ACCESS_SCOPE_TITLES } from "../../http/types/accessControl";
import { UserUsage } from "../../http/types/usageStatistics";
import { useUsersApi } from "../../http/useUsers";
import { formatUtcDay } from "../../utils";
import Table from "../ui/Table";

// What the user used, the most recent day first: one row per app visited and module used from it, or
// just the app when no module was used from it that day.
const AdminUserUsage: FC<{ userId: string }> = ({ userId }) => {
  const i18n = useI18n();
  const auth = useAuthContext();
  const usersApi = useUsersApi();
  const aborter = useRef(new AbortController());
  const filters = useListFilters({ prefix: "usage" });

  const { data, error } = usersApi.getAdminUserUsages(userId, filters.state, aborter.current.signal);

  return (
    <FlexContent direction="column">
      <Table<UserUsage>
        filters={filters}
        head={
          <TableRow>
            <TableHeadCell align="left">{i18n.translation.common.date}</TableHeadCell>
            <TableHeadCell align="left">{i18n.translation.accessControl.rules.app}</TableHeadCell>
            <TableHeadCell align="left">{i18n.translation.modules.singular}</TableHeadCell>
          </TableRow>
        }
        items={data?.items}
        total={data?.total}
        error={!!error}
        renderRow={(usage) => (
          <>
            <TableCell noWrap>{formatUtcDay(usage.date, auth.identity?.language)}</TableCell>
            <TableCell>{ACCESS_SCOPE_TITLES[usage.scope] ?? usage.scope}</TableCell>
            <TableCell>{usage.moduleName}</TableCell>
          </>
        )}
      />
    </FlexContent>
  );
};

export default AdminUserUsage;
